import { fade, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    clear: 'both',
    width: '100%',

    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },

    pageBreakInside: 'avoid !important',
  },
  chkimg: {
    width: '50%',
    float: 'right',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      float: 'none',
    },

    '& img': {
      width: '100%',
    },

    '@media print': {
      width: '50%',
      float: 'right',
    },
  },
  contentContainer: {
    padding: theme.spacing(1),

    [theme.breakpoints.down('sm')]: {
      width: `calc(100% - ${theme.spacing(4)}px)`,
    },
  },
  contentContainerNoImage: {
    width: '75%',
    margin: 'auto',
    padding: theme.spacing(1),

    [theme.breakpoints.down('sm')]: {
      width: `calc(100% - ${theme.spacing(4)}px)`,
    },

    '@media print': {
      width: '75%',
    },
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
  },
  hlRow: {
    backgroundColor: fade(theme.colors.danger, 0.15),
  },
  centerVertically: {
    alignItems: 'center',
  },
  imageRowSpacing: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(4),
  },
  buffer: {
    marginBottom: theme.spacing(1.5),
    pageBreakInside: 'avoid !important',
  },
  capitalize: {
    textTransform: 'capitalize',
  },
  iconContainer: {
    color: theme.palette.grey[500],
    marginRight: theme.spacing(1),
  },
  rowText: {
    fontSize: 14,

    '@media print': {
      fontSize: 12,
    },
  },
  additionalText: {
    fontWeight: 'bold',
    fontSize: 25,
    marginBottom: theme.spacing(2),
  },
  subText: {
    fontSize: 17,
    marginTop: theme.spacing(1),
  },
  checklistName: {
    fontWeight: 'bold',
    fontSize: 20,
    marginBottom: theme.spacing(2),
  },
  editButton: {
    marginRight: theme.spacing(1),
    '@media print': {
      display: 'none',
    },
  },
  form: {
    margin: theme.spacing(1),
  },
  formLoading: {
    pointerEvents: 'none',
    opacity: 0.5,
  },
  editButtonRow: {
    padding: theme.spacing(2),
    marginTop: -theme.spacing(2),
  },
  dangerBg: {
    backgroundColor: fade(theme.colors.danger, 0.15),
  },
}));

export default useStyles;
